import {create} from 'zustand'

interface LoadingState {
  contador: number
  isLoading: boolean
  iniciar: () => void
  finalizar: () => void
}

let loadingTimer: ReturnType<typeof setTimeout> | undefined

export const useLoadingStore = create<LoadingState>(set => ({
  contador: 0,
  isLoading: false,
  iniciar: () => {
    clearTimeout(loadingTimer)
    set(state => ({contador: state.contador + 1, isLoading: true}))
  },
  finalizar: () => {
    set(state => ({contador: Math.max(0, state.contador - 1)}))
    clearTimeout(loadingTimer)
    loadingTimer = setTimeout(() => {
      set(state => ({isLoading: state.contador > 0}))
    }, 300)
  },
}))

export function iniciarLoading() {
  useLoadingStore.getState().iniciar()
}

export function finalizarLoading() {
  useLoadingStore.getState().finalizar()
}

export async function comLoading<T>(operacao: Promise<T>): Promise<T> {
  iniciarLoading()

  try {
    return await operacao
  } finally {
    finalizarLoading()
  }
}
